import { render, staticRenderFns } from "./requestScanUploadComment.vue?vue&type=template&id=1d43ab71&"
import script from "./requestScanUploadComment.vue?vue&type=script&lang=js&"
export * from "./requestScanUploadComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports